import { ContactColumns } from "src/modules/contacts/types";
import { clearMergeTagName } from "src/helpers/customFieldMergeTag";

export const normalizeContactImportColumns = (columns: ContactColumns): ContactColumns => ({
  ...columns,
  customFields: columns.customFields.map(customField => ({
    ...customField,
    fieldName: clearMergeTagName(customField.fieldName),
  })),
});

